import { ReactNode } from 'react';

import Popup from '@/components/Popup/PopUp/PopUp';
import Button from '@/components/shared/Button/Button';
import { Text } from '@/components/shared/Text/Text';

interface JourneyConfirmModalProps {
  isOpen: boolean;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  danger?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const JourneyConfirmModal = ({
  isOpen,
  title,
  children,
  confirmLabel,
  danger,
  onConfirm,
  onClose,
}: JourneyConfirmModalProps) => (
  <Popup isOpen={isOpen} handleClose={onClose} maxWidth={440} withClose={false}>
    <Text.Big weight="bold" className="mb-2">
      {title}
    </Text.Big>
    <Text.Regular className="text-neutral-60 mb-6">{children}</Text.Regular>
    <div className="flex justify-end gap-2">
      <Button label="Cancel" variant="secondary" size="s" className="!w-24" onClick={onClose} />
      <Button
        label={confirmLabel}
        variant={danger ? 'danger' : 'primary'}
        size="s"
        className="!w-fit px-5"
        onClick={onConfirm}
      />
    </div>
  </Popup>
);

export default JourneyConfirmModal;
